import { BulkOperationsResponse } from "PFCore/services/bulk_operations";
import {
  Id,
  ImportBase,
  PaginatedCollection,
  QueryParams,
  UsersImportRow,
  UsersImportRowState
} from "PFTypes";

import api from "../../api";

export type UsersImport = ImportBase & Pick<BulkOperationsResponse, "state">;

export type UsersImportsParams = Pick<QueryParams, "page" | "perPage"> & {
  search?: string;
  order?: { direction: string } | null;
};

export type UsersImportsResponse = PaginatedCollection<UsersImport[]>;

export const fetchUsersImports = (params?: UsersImportsParams) =>
  api<UsersImportsResponse>({
    url: "users/imports",
    params: { ...params }
  });

export type UserImportRowsParams = {
  state?: UsersImportRowState;
  page?: number;
  perPage?: number;
};

export type UserImportRowsResponse = PaginatedCollection<
  UsersImportRow[],
  Record<"total" | UsersImportRowState, number>
>;

export const fetchUsersImportRows = (id: Id, params?: UserImportRowsParams) =>
  api<UserImportRowsResponse>({
    url: `users/imports/${id}/import_rows`,
    params
  });
